import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {useQuery} from "@tanstack/react-query";
import referralsService from "../../../../services/web/referrals-service.js";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaPlus, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const ReferralsList = () => {
    const navigate = navigateHook();

    const [isLoading, setIsLoading] = useState(false)
    const [columnDefs, setColumnDefs] = useState([]);
    const [filter, setFilter] = useState(null)
    const gridRef = useRef();
    const theme = useMemo(() => {
        return aggridUtils.generalTheme();
    }, []);

    useEffect(() => {
        const columns = [
            {
                headerName: "Nome", field: "name", flex: 1
            }
        ];

        setColumnDefs(columns);
    }, []);

    const { status, data: referrals } = useQuery({
        queryFn: () =>  referralsService.list().then(({data}) => {
            return data
        }),
        queryKey: ['referrals'],
    });

    useEffect(() => {
        if (status === 'success') setIsLoading(false)
        else setIsLoading(true)
    }, [status]);

    const onCellClicked = ({data}) => {
        let isBlank = false;
        let urlDev = `/referrals/form/${data.id}`;
        navigate(urlDev, isBlank);
    }

    const clearFilter = () => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            null,
        );

        setFilter("");
    }

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef.current.api.setGridOption(
            "quickFilterText",
            filter,
        );
    }, [filter]);

    const onChange = ({target: {value}}) => {
        setFilter(value)
    }

    const newReferral = () => {
        let isBlank = false;
        let urlDev = `/referrals/form`;
        navigate(urlDev, isBlank);
    }

    useGlobalKey("Enter", onFilterTextBoxChanged);
    useGlobalKey("Escape", clearFilter);
    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Encaminhamentos</Template.Title>
                <Button onClick={() => newReferral()}>
                    <FaPlus /> Adicionar encaminhamento
                </Button>
            </Template.Header>
            <Template.Body className="flex flex-col space-y-2">
                <Card>
                    <Card.Body>
                        <div className="flex items-end gap-4">
                            <div className="flex-1">
                                <InputForm id="name" value={filter} onChange={onChange}
                                           label="Nome"/>
                            </div>

                            <div className="flex gap-2">
                                <Button target="text-white" title="Limpar" onClick={() => clearFilter()}>
                                    <FaEraser />
                                </Button>

                                <Button target="primary" title="Buscar" onClick={() => onFilterTextBoxChanged()}>
                                    <FaSearch />
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <Card>
                    <Card.Body className="flex">
                        <div className="h-[calc(100vh-153px)] w-full">
                            <AgGridReact
                                ref={gridRef}
                                rowData={referrals}
                                columnDefs={columnDefs}
                                pagination
                                paginationPageSize={100}
                                paginationPageSizeSelector={[20, 50, 100, 500]}
                                animateRows={false}
                                suppressCellFocus={true}
                                onCellClicked={onCellClicked}
                                gridOptions={{localeText: aggridUtils.localization()}}
                                onFilterChanged={aggridUtils.filterChangedNoRowsOverlay}
                                theme={theme}
                            />
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default ReferralsList;